"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GTMEvent = void 0;

var _upperCase = _interopRequireDefault(require("lodash/upperCase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GTMEvent = function GTMEvent(newLaneEventData) {
  if (typeof window !== 'undefined') {
    var snakeCasePlacementName = (0, _upperCase.default)(newLaneEventData.placement_nm).split(' ').join('_');
    var event = "MTT_" + snakeCasePlacementName + "_ONSITE_MESSAGING." + newLaneEventData.selected_treatment_nm;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event
    });
  }
};

exports.GTMEvent = GTMEvent;